import React from 'react';
import styled, { css } from 'styled-components';

interface NoticeLinkProps {
  newLine: boolean;
}

export const NoticeLink = styled.a<NoticeLinkProps>`
  ${({ newLine }) =>
  newLine
    ? css`
          display: block;
          margin-top: 5px;
        `
    : ''}
  white-space: nowrap;
  text-decoration: underline;

  && {
    border-bottom: none;
  }
`;